export function isRolePermissionResponse(value) {
    if (!value || typeof value !== 'object')
        return false;
    const a = value.assignment;
    return Boolean(a &&
        typeof a.roleId === 'string' &&
        typeof a.roleCode === 'string' &&
        typeof a.roleName === 'string' &&
        typeof a.isActive === 'boolean' &&
        typeof a.isSystem === 'boolean' &&
        Number.isInteger(a.userCount) &&
        Number.isInteger(a.version) &&
        Array.isArray(a.permissions) &&
        a.permissions.every((p) => p &&
            typeof p.id === 'string' &&
            typeof p.code === 'string' &&
            typeof p.name === 'string' &&
            typeof p.description === 'string' &&
            typeof p.module === 'string' &&
            typeof p.selected === 'boolean'));
}
